<template>
    <div>
      <div class="card card-body p-0" style="border-radius: 10px">
        <module_table :webinars="webinars" :totalPages="totalPages" :page="page" @setPage="setPage" @setSearch="setSearch" :setSkeletonLoader="displayLoader"></module_table>
      </div>
    </div>
  </template>
  
  <script>
    import Loading from "vue-loading-overlay";
    import VueSkeletonLoader from 'skeleton-loader-vue';
    import Table from "./table.vue";
    export default {
      components: {
        "module_table": Table,VueSkeletonLoader,
        Loading,
      },
      data: function () {
        return {
          page: 1,
          search: '',
          fullPage: "",
          displayLoader: true,
        };
      },
      computed: {
        webinars: function () {
          return this.$store.getters["webinar/webinars"];
        },
        totalPages: function () {
          return this.$store.getters['webinar/totalPages'];
        },

      },
      created() {
        this.getWebinars(this.page,this.search)
      },
      watch: {
        page: function (val) {
          this.getWebinars(val,this.search)
        },

        search: function (){
          this.getWebinars(this.page, this.search)
        }
      },
      methods: {
        setPage(page) {
          this.page = page;
        },
        setSearch(search){
          this.search = search || ''
        },
        setSkeletonLoader(val){
          this.displayLoader = val;
          this.$forceUpdate();
        },


        getWebinars(page,search){
          this.setSkeletonLoader(true);
          this.$store.dispatch("webinar/getAllwebinars",[page, search])
              .then(() => {
                setTimeout(() => {
                  this.setSkeletonLoader(false);
                }, 500);
              }).catch(() => {
                this.setSkeletonLoader(true);
        });
        }
      },
    };
  </script>
  <style>
    .custom {
      position: absolute;
      z-index: 999;
      top: 246px;
      left: 40%;
      opacity: 0.5;
    }
  </style>